import {useUserEmail} from 'src/hooks/useUserEmail';
import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';

import {EventCodeSuggestions, StringFilterItem, SuggestionType} from '../typedefs';

const MIN_QUERY_SUGGEST = 1;
const MAX_SUGGESTIONS = 100;

export const getPartialCaption = (
    suggestions: StringFilterItem[],
    suggestionType:
    SuggestionType,
    withSeparator = false,
) => {
    const count = Math.min(suggestions.length, MAX_SUGGESTIONS);
    const suffix = suggestions.length > MAX_SUGGESTIONS ? ` of ${suggestions.length}` : '';
    const separator = withSeparator ? ' |' : '';
    return `${suggestionType}: ${count} results${suffix}${separator}`;
};

export const useEventCodeSuggestions = (
    query: string,
    eventsInfoMapped: StringFilterItem[],
    changeRequestsMapped: StringFilterItem[],
): EventCodeSuggestions => {
    const userEmail = useUserEmail();

    const upperQuery = query.toUpperCase();
    const hasQuery = query.length >= MIN_QUERY_SUGGEST;

    if (!hasQuery) {
        return {
            changeRequestItems: [],
            eventItems: [],
            summaryCaption: '',
        };
    }

    const filteredEventSuggestions = eventsInfoMapped.filter(event => event.name.includes(upperQuery));
    const filteredChangeRequestSuggestions = changeRequestsMapped.filter(suggestion =>
        suggestion.status !== ChangeRequestStatus.WAITING_REVIEW &&
        suggestion.authorEmail === userEmail &&
        suggestion.name.includes(upperQuery));

    const changeRequestCaption =
        getPartialCaption(filteredChangeRequestSuggestions, SuggestionType.CHANGE_REQUEST, true);
    const eventsCaption = getPartialCaption(filteredEventSuggestions, SuggestionType.EVENTS);

    return {
        changeRequestItems: filteredChangeRequestSuggestions.slice(0, MAX_SUGGESTIONS),
        eventItems: filteredEventSuggestions.slice(0, MAX_SUGGESTIONS),
        summaryCaption: `${changeRequestCaption} ${eventsCaption}`,
    };
};
